module.exports = __webpack_public_path__ + "img/Dantam Makeover 09.83cf23db.jpg";